/* eslint-disable react/state-in-constructor */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Form } from 'antd';
import { Grid, TextField, Snackbar, Button, Typography, Select, MenuItem, InputLabel, IconButton, Divider } from '@material-ui/core';
import { AddCircle as AddCircleIcon, Delete as DeleteIcon } from '@material-ui/icons';
import MySnackbarContentWrapper from '../../../../components/SnackBar';
import { getFriendlyErrorMessage } from '../../../../utils/errorHelper';

class productTypeForm extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    snackOpen: false,
    snackType: 'info',
    snackMessage: 'Action executing...',
    dynamicFieldsList: this.props.dynamicFields ? JSON.parse(this.props.dynamicFields) : [{ fieldName: '', fieldValue: '' }],
    disclaimerFieldsList: this.props.disclaimerByLanguage ? JSON.parse(this.props.disclaimerByLanguage) : [{ disclaimerValue: '', disclaimerLanguage: '' }],
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  setStateValues = (open, type, message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ snackOpen: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.query_f({
          variables: {
            id: this.props.id,
            name: values.name,
            disclaimer: values.disclaimer,
            dynamicFields: JSON.stringify(this.state.dynamicFieldsList),
            disclaimerByLanguage: JSON.stringify(this.state.disclaimerFieldsList),
          },
        }).then(() => {
          this.setStateValues(true, 'success', 'Action executed with success!');
          if (this.props.onCancel) {
            this.props.onCancel();
          }
        }, error => {
          this.setStateValues(true, 'error', getFriendlyErrorMessage(error));
        });
      } else {
        this.setStateValues(true, 'error', 'Form validation failed!');
      }
    });
  }

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.dynamicFieldsList];
    list[index][name] = value;
    this.setState({ dynamicFieldsList: list });
  };

  handleInputChangeDisclaimerValue = (e, index) => {
    const { value } = e.target;
    const list = [...this.state.disclaimerFieldsList];
    list[index].disclaimerValue = value;
    this.setState({ disclaimerFieldsList: list });
  };

  handleInputChangeLanguage = (e, index) => {
    const { value } = e.target;
    const list = [...this.state.disclaimerFieldsList];
    list[index].disclaimerLanguage = value;
    this.setState({ disclaimerFieldsList: list });
  };

  handleRemoveClick = index => {
    const list = [...this.state.dynamicFieldsList];
    list.splice(index, 1);
    this.setState({ dynamicFieldsList: list });
  };

  handleAddClick = () => {
    this.setState({ dynamicFieldsList: [...this.state.dynamicFieldsList, { fieldName: '', fieldValue: '' }] });
  };

  handleRemoveLanguageClick = index => {
    const list = [...this.state.disclaimerFieldsList];
    list.splice(index, 1);
    this.setState({ disclaimerFieldsList: list });
  };

  handleAddLanguageClick = () => {
    this.setState({ disclaimerFieldsList: [...this.state.disclaimerFieldsList, { disclaimerValue: '', disclaimerLanguage: '' }] });
  };

  handleChange = (set, event) => {
    if (event.target.value || event.target.value === '' || event.target.value === 0) {
      set(event.target.value);
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <form id="myForm" onSubmit={this.handleSubmit}>
          <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackOpen} autoHideDuration={6000} onClose={this.handleClose}>
            <MySnackbarContentWrapper onClose={this.handleClose} variant={this.state.snackType} message={this.state.snackMessage} />
          </Snackbar>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              {getFieldDecorator('name', { initialValue: (this.props.name || ''), rules: [{ required: true }] })(
                <TextField id="name" label="name" color="primary" fullWidth style={{ marginTop: 13 }} multiline={(!this.props.name)} InputLabelProps={{ shrink: true }} placeholder="" />,
              )}
            </Grid>
            <Grid item xs={12}>
              {getFieldDecorator('disclaimer', { initialValue: (this.props.disclaimer || '') })(
                <TextField
                  id="disclaimer"
                  label="disclaimer"
                  color="primary"
                  multiline
                  rowsMax={8}
                  fullWidth
                  style={{ marginTop: 13 }}
                  InputLabelProps={{ shrink: true }}
                  placeholder=""
                />,
              )}
            </Grid>
          </Grid>
        </form>

        <Grid container spacing={0}>
          <Grid item xs={10}>
            <Typography style={{ marginTop: 30 }} variant="h5" size="sm">
              Dynamic fields
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Button
              style={{ marginTop: 30, width: '100%' }}
              color="primary"
              variant="outlined"
              startIcon={<AddCircleIcon />}
              onClick={this.handleAddClick}
            >
              Add
            </Button>
          </Grid>
        </Grid>
        {this.state.dynamicFieldsList.map((x, i) => {
          return (
            <Grid container spacing={0}>
              <Grid item xs={5}>
                <TextField
                  name="fieldName"
                  label="Field Name"
                  value={x.fieldName}
                  color="primary"
                  style={{ marginTop: 13, width: '100%' }}
                  InputLabelProps={{ shrink: true }}
                  placeholder=""
                  onChange={e => this.handleInputChange(e, i)}
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  className="ml10"
                  name="fieldValue"
                  label="Field Value"
                  value={x.fieldValue}
                  color="primary"
                  style={{ marginTop: 13, width: '100%' }}
                  InputLabelProps={{ shrink: true }}
                  placeholder=""
                  onChange={e => this.handleInputChange(e, i)}
                />
              </Grid>
              <Grid item xs={2}>
                {this.state.dynamicFieldsList.length !== 1 && (
                  <IconButton
                    aria-label="delete"
                    style={{ marginTop: 13, width: '100%' }}
                    onClick={() => this.handleRemoveClick(i)}
                  >
                    <DeleteIcon color="primary" />
                  </IconButton>
                )}
              </Grid>

            </Grid>
          );
        })}

        <Grid container spacing={0}>
          <Grid item xs={10}>
            <Typography style={{ marginTop: 30 }} variant="h5" size="sm">
              Disclaimer by language
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Button
              style={{ marginTop: 30, width: '100%' }}
              color="primary"
              variant="outlined"
              startIcon={<AddCircleIcon />}
              onClick={this.handleAddLanguageClick}
            >
              Add
            </Button>
          </Grid>
        </Grid>
        {
          this.state.disclaimerFieldsList.map((x, i) => {
            return (
              <Grid container spacing={0}>
                <Grid item xs={5}>
                  <InputLabel style={{ fontSize: 12, marginTop: 13, width: '100%' }}>Disclaimer language</InputLabel>
                  <Select
                    fullWidth
                    id="language"
                    label="Disclaimer Language"
                    labelId="select-settings-language"
                    value={x.disclaimerLanguage}
                    style={{ marginTop: 4, marginBottom: 20, width: '100%' }}
                    onChange={e => this.handleInputChangeLanguage(e, i)}
                  >
                    <MenuItem value="en" key="en">English</MenuItem>
                    <MenuItem value="pt" key="pt">Portuguese</MenuItem>
                    <MenuItem value="ar" key="ar">Arabic</MenuItem>
                    <MenuItem value="de" key="de">German</MenuItem>
                    <MenuItem value="es" key="es">Spanish</MenuItem>
                    <MenuItem value="fr" key="fr">French</MenuItem>
                    <MenuItem value="id" key="id">Indonesian</MenuItem>
                    <MenuItem value="it" key="it">Italian</MenuItem>
                    <MenuItem value="jp" key="jp">Japanese</MenuItem>
                    <MenuItem value="other" key="other">Other</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    name="disclaimerValue"
                    label="Disclaimer Text"
                    value={x.disclaimerValue}
                    multiline
                    rowsMax={8}
                    color="primary"
                    style={{ marginTop: 13, marginBottom: 20, width: '100%' }}
                    InputLabelProps={{ shrink: true }}
                    placeholder="Type disclaimer here..."
                    onChange={e => this.handleInputChangeDisclaimerValue(e, i)}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={2}>
                  {this.state.disclaimerFieldsList.length !== 1 && (
                    <IconButton
                      aria-label="delete"
                      style={{ marginTop: 13, width: '100%' }}
                      onClick={() => this.handleRemoveLanguageClick(i)}
                    >
                      <DeleteIcon color="primary" />
                    </IconButton>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Divider light />

                </Grid>
              </Grid>
            );
          })
        }
      </>
    );
  }
}

const productTypesForm = Form.create()(productTypeForm);

export default productTypesForm;
